import { seedExperiences } from './seedExperiences';
import { seedEducation } from './seedEducation';
import { seedPublications } from './seedPublications';

/**
 * Initialize Firebase collections with seed data
 * This should be called once the app is initialized
 */
export const initializeFirebaseData = async () => {
    try {
        console.log('Initializing Firebase data...');

        // Seed experiences
        await seedExperiences();

        // Seed education
        await seedEducation();

        // Seed publications
        await seedPublications();

        console.log('Firebase data initialization complete');
    } catch (error) {
        console.error('Error initializing Firebase data:', error);
    }
};

export default initializeFirebaseData; 